import TableCellNoResult from './tableCell';

export default TableCellNoResult;